<template lang="pug">
  v-card.pa-6.round-xl(v-if="toDisplaySummary" outlined)
    // Credit balance
    credit-balance(ref="creditBalance")
    // SMS deliverance summary
    div.text-md.font-semibold.neutral700--text SMS deliverance summary
    // Offer message
    template(v-if="hasOfferBlastEnabled")
      div.text-xs.font-bold.neutral700--text.mt-5 Offer message
      v-simple-table.custom-simple-table.mt-2(dense)
        thead
          tr
            th Customers
            th Frequency
            th.text-right Total message
        tbody
          tr
            td.text-sm.neutral700--text {{ totalSelectedCustomers | displayNumber }}
            td.text-sm.neutral700--text {{ offerBlastFrequency | displayNumber }}
            td.text-sm.neutral700--text.text-right {{ offerTotalMessage | displayNumber }}
      v-divider
    // Thank you message
    template(v-if="hasThankyouBlastEnabled")
      div.text-xs.font-bold.neutral700--text.mt-5 Thank you message
      v-simple-table.custom-simple-table.mt-2(dense)
        thead
          tr
            th Customers
            th Frequency
            th.text-right Total message
        tbody
          tr
            td.text-sm.neutral700--text {{ totalSelectedCustomers | displayNumber }}
            td.text-sm.neutral700--text {{ thankyouBlastFrequency | displayNumber }}
            td.text-sm.neutral700--text.text-right {{ thankyouTotalMessage | displayNumber }}
      v-divider
    // Total
    div.d-flex.align-center.mt-6
      div.text-lg.font-bold.neutral700--text Total:
      v-spacer
      div.text-lg.font-bold.neutral700--text {{ grandTotal | displayPrice }}
    // Insufficient balance alert
    v-alert.mt-6.round-xl(v-if="!hasSufficientBalance" color="danger500" text)
      div.d-flex.align-center
        v-icon(size="18" color="danger500") $yzi-alert-square
        div.text-xs.neutral700--text.px-2
          span.danger500--text.mr-1 Insufficient balance:
          | Your SMS credit balance is insufficient for this campaign
        v-spacer
        y-button(label="Reload" outlined size="sm"  @click="handleOpenCreditReload")
    // Important notes
    v-alert.mt-6.round-xl(color="warning500" text)
      div.text-xs.neutral700--text.px-2
        span.warning600--text.mr-1 Note:
        | It is important to have sufficient balance for this SMS campaign to prevent any blasting errors when the campaign administered.
</template>

<script>
import CreditBalance from '@/components/clinic/marketing/CreditBalance.vue'
import {mapGetters} from "vuex";

export default {
  components: {
    CreditBalance,
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      summary: 'marketing/getSummary',
      setting: 'marketing/getMarketingSettings',
      offer: 'marketing/getOffer',
      blasts: 'marketing/getBlasts'
    }),
    toDisplaySummary() {
      return this.enabledBlasts.length > 0
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
    totalSelectedCustomers() {
      if (this.offer.to_all_customers) {
        return this.summary.totalCustomers
      }
      let total = 0
      if (this.offer.to_all_loyalty_members) total += this.summary.totalLoyaltyMembers
      if (this.offer.groups && this.offer.groups.length > 0) total += this.offer.groups.length
      if (this.offer.customers && this.offer.customers.length > 0) total += this.offer.customers.length
      return total
    },
    enabledBlasts() {
      return this.blasts.filter(blast => blast.method === 'sms' && blast.enabled)
    },
    offerBlast() {
      return this.enabledBlasts.find(blast => blast.type === 'offer') || null
    },
    thankyouBlast() {
      return this.enabledBlasts.find(blast => blast.type === 'thank_you') || null
    },
    hasOfferBlastEnabled() {
      return this.offerBlast !== null
    },
    hasThankyouBlastEnabled() {
      return this.thankyouBlast !== null
    },
    offerBlastFrequency() {
      return this.offerBlast?.frequency ?? 0
    },
    thankyouBlastFrequency() {
      return this.thankyouBlast?.frequency ?? 0
    },
    hasSmsHeader() {
      return this.setting && this.setting.sms_header
    },
    senderID() {
      let text = null
      if (this.hasSmsHeader) {
        text = `RM0 ${this.setting.sms_header}`
      }
      return text
    },
    senderIDPrefix() {
      return `${this.senderID}: `
    },
    replaceCodeValue() {
      if (this.offer.redeem_method === 'unique_code') return 'CODE'
      if (this.offer.redeem_method === 'general_code') return this.offer.coupon_code
      return ''
    },
    replaceExpiryDataValue() {
      if (this.offer.end_at) return this.$options.filters.displayDate(this.offer.end_at)
      return ''
    },
    replaceBrandNameValue() {
      if (this.hasSmsHeader) return this.setting.sms_header
      return ''
    },
    offerMessagePerCustomer() {
      if (!this.offerBlast) return 0
      return this.contentLength(this.offerBlast.content)
    },
    offerTotalMessage() {
      return this.offerMessagePerCustomer * this.totalSelectedCustomers * this.offerBlastFrequency
    },
    thankyouMessagePerCustomer() {
      if (!this.thankyouBlast) return 0
      return this.contentLength(this.thankyouBlast.content)
    },
    thankyouTotalMessage() {
      return this.thankyouMessagePerCustomer * this.totalSelectedCustomers * this.thankyouBlastFrequency
    },
    grandTotal() {
      const smsPricePerMessage = 15 // RM0.15
      return (this.offerTotalMessage + this.thankyouTotalMessage) * smsPricePerMessage
    },
    hasSufficientBalance() {
      return this.creditBalance >= this.grandTotal
    }
  },
  methods: {
    contentLength(content = '') {
      let text = content
      text = text + this.senderIDPrefix
      text = text.replace(/{{ offer_code }}/g, this.replaceCodeValue)
      text = text.replace(/{{ expiry_date }}/g, this.replaceExpiryDataValue)
      text = text.replace(/{{ brand_name }}/g, this.replaceBrandNameValue)
      const length = text ? text.length : 0;
      const charLength = 155
      return Math.ceil(length / charLength)
    },
    handleOpenCreditReload() {
      this.$refs.creditBalance.openReload()
    }
  },
}
</script>

<style scoped>

</style>